import * as React from 'react';
import {withRouter} from 'react-router-dom';
import {IProduct} from "../../functions/Interfaces";
import ProductCatalog from '../product/ProductCatalog';
import { Typography } from '@material-ui/core';

class Category extends React.Component<any,{ products: IProduct[]; keyword: string }> {
  public render() {
    const categoryRes: IProduct[] = getCategoryResults(
      this.props.products,
      this.props.keyword
    );
    const title: string =
      this.props.keyword === "women" ? "Women's Fashion" : "Men's Fashion";

    if (categoryRes.length !== 0) {
      return (
        <div>
          <Typography color="primary" align="center" variant="h2">
            {title}
          </Typography>
          <ProductCatalog
            products={categoryRes}
            actionUpdate={this.props.actionUpdate}
          />
        </div>
      );
    } else {
      return <div>Keine Ergebnisse</div>;
    }
  }
}
export default withRouter(Category);

function getCategoryResults(products: IProduct[], keyword: string): IProduct[] {
  let res: IProduct[] = [];
  products.forEach((product: IProduct) => {
    for (const category of product.category) {
      // for (let i : number = 0; i < product.category.length; i++) {
     if (category.toLocaleLowerCase().includes(keyword)) {
          if(keyword.match("men") && !category.toLocaleLowerCase().includes("women")) {
            res = res.concat(product);
          } 
          if (keyword.match("women")) {
            res = res.concat(product);
          }
     }
    }
  });
  return res;
}  


// WEBPACK FOOTER //
// ./src/components/categories/Category.tsx